<div class="mini-compass"
     [style.width.px]="size"
     [style.height.px]="size"
     [style.--r.px]="radius">

  <div class="mini-compass__dial">

    <!-- Tick marks — transform-origin uses --r to pivot at circle centre -->
    @for (i of [].constructor(tickCount); track $index) {
      <div class="mini-compass__tick"
           [class.mini-compass__tick--major]="$index % 9 === 0"
           [style.transform]="'rotate(' + ($index * (360 / tickCount)) + 'deg)'">
      </div>
    }

    <!-- All 8 cardinal/intercardinal labels -->
    @for (pt of compassPoints; track pt.label) {
      <div class="mini-compass__label"
           [class.mini-compass__label--north]="pt.isNorth"
           [class.mini-compass__label--cardinal]="pt.isCardinal"
           [style.transform]="'rotate(' + pt.deg + 'deg) translateY(calc(-1 * var(--label-r))) rotate(' + (-pt.deg) + 'deg)'">
        {{ pt.label }}
      </div>
    }
  </div>

  <!-- Qibla needle -->
  <div class="mini-compass__needle-wrap"
       [style.transform]="'rotate(' + needleRotation + 'deg)'">
    <div class="mini-compass__needle"></div>
    <div class="mini-compass__kaaba">🕋</div>
  </div>

  <!-- Centre hub -->
  <div class="mini-compass__hub">🕌</div>

</div>
